export default function GovernmentsToolbarIcon() {
  return (
    <svg width={20} height={20} viewBox="0 -1 512 511">
      <path d="M73.766 211.945h49.703v201.97H73.766zm0 0" fill="#e6f1fa" />
      <path d="M101.469 211.945h22v201.97h-22zm0 0" fill="#cee4f7" />
      <path
        d="M471.367 157.102L259.414 10.363a5.998 5.998 0 0 0-6.828 0L40.636 157.102v16.566h430.731zm0 0"
        fill="#e6f1fa"
      />
      <path
        d="M259.414 10.363a5.998 5.998 0 0 0-6.828 0L245 15.617l204.367 141.485v16.566h22v-16.566zm0 0"
        fill="#cee4f7"
      />
      <path
        d="M272.566 107.402c0 9.149-7.414 16.567-16.566 16.567-9.148 0-16.566-7.418-16.566-16.567 0-9.152 7.418-16.57 16.566-16.57 9.152 0 16.566 7.418 16.566 16.57zm0 0"
        fill="#feda43"
      />
      <path
        d="M134.035 223.367H63.2c-3.312 0-6-2.687-6-6v-37.922h82.836v37.922c0 3.313-2.687 6-6 6zm0 0"
        fill="#537d91"
      />
      <path d="M118.035 179.445v37.922c0 3.313-2.687 6-6 6h22c3.313 0 6-2.687 6-6v-37.922zm0 0" fill="#45738a" />
      <path
        d="M134.035 402.496H63.2c-3.312 0-6 2.684-6 6v37.918h82.836v-37.918c0-3.316-2.687-6-6-6zm0 0"
        fill="#537d91"
      />
      <path d="M118.035 446.414v-37.922c0-3.312-2.687-6-6-6h22c3.313 0 6 2.688 6 6v37.922zm0 0" fill="#45738a" />
      <path d="M231.148 211.945h49.704v201.97h-49.704zm0 0" fill="#e6f1fa" />
      <path d="M258.852 211.945h22v201.97h-22zm0 0" fill="#cee4f7" />
      <path
        d="M291.418 223.367h-70.832c-3.316 0-6-2.687-6-6v-37.922h82.832v37.922c0 3.313-2.688 6-6 6zm0 0"
        fill="#537d91"
      />
      <path d="M275.418 179.445v37.922c0 3.313-2.688 6-6 6h22c3.312 0 6-2.687 6-6v-37.922zm0 0" fill="#45738a" />
      <path
        d="M291.418 402.496h-70.832c-3.316 0-6 2.684-6 6v37.918h82.832v-37.918c0-3.316-2.688-6-6-6zm0 0"
        fill="#537d91"
      />
      <path d="M275.418 446.414v-37.922c0-3.312-2.688-6-6-6h22c3.312 0 6 2.688 6 6v37.922zm0 0" fill="#45738a" />
      <path d="M388.531 211.945h49.703v201.97h-49.703zm0 0" fill="#e6f1fa" />
      <path d="M416.234 211.945h22v201.97h-22zm0 0" fill="#cee4f7" />
      <path
        d="M448.8 223.367h-70.835c-3.313 0-6-2.687-6-6v-37.922H454.8v37.922c0 3.313-2.688 6-6 6zm0 0"
        fill="#537d91"
      />
      <path d="M432.8 179.445v37.922c0 3.313-2.687 6-6 6h22c3.313 0 6-2.687 6-6v-37.922zm0 0" fill="#45738a" />
      <path
        d="M448.8 402.496h-70.835c-3.313 0-6 2.684-6 6v37.918H454.8v-37.918c0-3.316-2.688-6-6-6zm0 0"
        fill="#537d91"
      />
      <path d="M432.8 446.414v-37.922c0-3.312-2.687-6-6-6h22c3.313 0 6 2.688 6 6v37.922zm0 0" fill="#45738a" />
      <path
        d="M481.934 190.234H30.066c-3.312 0-6-2.687-6-6v-21.132c0-3.317 2.688-6 6-6h451.868c3.312 0 6 2.683 6 6v21.132c0 3.313-2.688 6-6 6zm0 0"
        fill="#feda43"
      />
      <path
        d="M481.934 157.102h-22c3.312 0 6 2.683 6 6v21.132c0 3.313-2.688 6-6 6h22c3.312 0 6-2.687 6-6v-21.132c0-3.317-2.688-6-6-6zm0 0"
        fill="#fdb53e"
      />
      <path d="M487.934 485.328H24.066v-43.7c0-3.312 2.688-6 6-6h451.868c3.312 0 6 2.688 6 6zm0 0" fill="#feda43" />
      <path d="M481.934 435.629h-22c3.312 0 6 2.687 6 6v43.7h22v-43.7c0-3.313-2.688-6-6-6zm0 0" fill="#fdb53e" />
      <path
        d="M498.5 501.895h-485c-3.313 0-6-2.688-6-6v-21.133c0-3.313 2.688-6 6-6h485c3.313 0 6 2.687 6 6v21.133c0 3.312-2.688 6-6 6zm0 0"
        fill="#e6f1fa"
      />
      <path
        d="M498.5 468.762h-22c3.313 0 6 2.687 6 6v21.133c0 3.312-2.688 6-6 6h22c3.313 0 6-2.688 6-6v-21.133c0-3.313-2.688-6-6-6zm0 0"
        fill="#cee4f7"
      />
      <path d="M256 131.469c13.273 0 24.066-10.797 24.066-24.067 0-13.273-10.796-24.07-24.066-24.07s-24.066 10.797-24.066 24.07c0 13.27 10.796 24.067 24.066 24.067zm0-33.137c5 0 9.066 4.07 9.066 9.07 0 4.996-4.066 9.067-9.066 9.067s-9.066-4.067-9.066-9.067 4.066-9.07 9.066-9.07zm0 0" />
      <path d="M504.5 461.262h-9.066v-25.633c0-4.14-3.36-7.5-7.5-7.5H462.3v-25.633a7.5 7.5 0 0 0-7.5-7.5h-9.063V230.867h9.063a7.5 7.5 0 0 0 7.5-7.5v-25.633h25.633a7.5 7.5 0 0 0 7.5-7.5v-33.132a7.5 7.5 0 0 0-7.5-7.5H473.71L260.27 1.832a7.504 7.504 0 0 0-8.54 0L38.293 149.602H24.066a7.5 7.5 0 0 0-7.5 7.5v33.132c0 4.141 3.36 7.5 7.5 7.5H49.7v25.633c0 4.14 3.36 7.5 7.5 7.5h9.067v164.13h-9.067a7.5 7.5 0 0 0-7.5 7.5v25.632H24.066c-4.14 0-7.5 3.36-7.5 7.5v25.633H7.5a7.497 7.497 0 0 0-7.5 7.5v33.129c0 4.144 3.355 7.5 7.5 7.5h497c4.145 0 7.5-3.356 7.5-7.5v-33.13a7.5 7.5 0 0 0-7.5-7.5zm-57.2-33.133H379.47v-18.133H447.3zm-51.269-33.133V230.867h34.703v164.13zm51.27-179.129h-67.832v-18.133H447.3zm-75.332 15h9.062v164.13h-9.062a7.497 7.497 0 0 0-7.5 7.5v25.632h-59.551v-25.633a7.5 7.5 0 0 0-7.5-7.5h-9.066V230.867h9.066c4.14 0 7.5-3.36 7.5-7.5v-25.633h59.55v25.633a7.5 7.5 0 0 0 7.5 7.5zm-149.883-33.133h67.832v18.133h-67.832zm16.562 33.133h34.704v164.13h-34.704zm51.27 179.13v18.132h-67.832v-18.133zM31.566 164.601H162.45a7.5 7.5 0 0 0 7.5-7.5c0-4.145-3.355-7.5-7.5-7.5H64.645L256 17.122l191.36 132.48H192.45a7.5 7.5 0 1 0 0 15h287.984v18.132H31.566zM64.7 197.734h67.836v18.133H64.7zm51.27 33.133v164.13H81.266v-164.13zm-51.27 179.13h67.836v18.132H64.7zm75.336-15h-9.066v-164.13h9.066c4.14 0 7.5-3.36 7.5-7.5v-25.633h59.55v25.633a7.5 7.5 0 0 0 7.5 7.5h9.063v164.13h-9.062a7.497 7.497 0 0 0-7.5 7.5v25.632h-59.55v-25.633a7.5 7.5 0 0 0-7.5-7.5zM31.566 443.128h448.868v18.133H31.566zM497 494.395H15v-18.133h482zm0 0" />
    </svg>
  );
}
